



































































import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {$, ID, successAndPush} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import {ItrackCollection} from '../../helpers'
import CnpjBulkLog from '../../model/resource/CnpjBulklog'

const metaInfo = () => ({
    title: $.t('view.persist.CnpjBulklogPersist.title'),
})

@Component({
    metaInfo,
})
export default class CnpjBulklogPersistView extends Vue {
    @Prop({type: [String, Number]}) id?: ID

    AppConfig = AppConfig
    allType = ItrackCollection.allTipoCnpjBulklog

    listToPersist: CnpjBulkLog[] = []

    get editMode() {
        return Boolean(this.id)
    }

    created() {
        this.$set(this.listToPersist, 0,  new CnpjBulkLog())
    }

    async mounted() {
        await this.allType.query()
        if (this.id) await this.listToPersist[0].getCnpjBulkLog(this.id)
        $.await.done('getCnpjBulkLog')
    }

    addItem() {
        this.listToPersist.push(new CnpjBulkLog())
    }

    removeItem(item: CnpjBulkLog) {
        const index = this.listToPersist.indexOf(item)
        if (index > -1) {
            this.listToPersist.splice(index, 1)
            this.$forceUpdate()
        }
    }

    async persist() {
        await CnpjBulkLog.persistLoteTipoOcorrencia(this.listToPersist)
        successAndPush('system.success.persist', '/manage/cnpj-bulklog/list')
    }
}
